export const POST_NOT_FOUND =
  "Sorry, we couldn't find that post. Please double check the URL.";
